import * as React from "react";
import Async from "react-async";
import SpinnerContainer, { SpinnerBox } from "../Spinner";
import ErrorScreen from "../ErrorScreen";

const AsyncLoader = ({
  children,
  promiseFn,
  deferFn,
  onReject,
  persistData,
  options,
  errorScreen: ErrorScreen
}) => /*#__PURE__*/React.createElement(Async, {
  promiseFn: promiseFn,
  deferFn: deferFn,
  onReject: onReject
}, /*#__PURE__*/React.createElement(Async.Pending, null, /*#__PURE__*/React.createElement(SpinnerContainer, {
  component: SpinnerBox
})), !persistData && /*#__PURE__*/React.createElement(Async.Rejected, null, error => /*#__PURE__*/React.createElement(ErrorScreen, {
  error: error,
  options: options
})), /*#__PURE__*/React.createElement(Async.Fulfilled, {
  persist: persistData
}, (data, asyncCallbackProps) => children(data, asyncCallbackProps)));

AsyncLoader.defaultProps = {
  errorScreen: ErrorScreen
};
export default AsyncLoader;